import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-proposta-analise',
    templateUrl: './proposta-analise.component.html',
    styleUrls: ['./proposta-analise.component.sass']
})
export class PropostaAnaliseComponent  extends BasePropostaComponent implements OnInit {

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public cepService: CepService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
        ) {
        super(injector);
    }

    async ngOnInit() {
        await this.inOnInit();
    }
}
